import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'antd'

import Layout from '../App/layout'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import ContentLayout from '../../components/utility/layoutContent'

import BasketSizeRatesTab from './BasketSizeRatesTab'
import FullTruckLoadRatesTab from './FullTruckLoadRatesTab'
import { BASE_PATH, FULL_TRUCK_LOAD_PATH } from './graphql'

const BASKET_SIZE_TAB = 'basket_size'
const FULL_TRUCK_LOAD_TAB = 'full_truck_load'

const TAB_PATHS = {
  [BASKET_SIZE_TAB]: BASE_PATH,
  [FULL_TRUCK_LOAD_TAB]: FULL_TRUCK_LOAD_PATH
}

const CustomerShippingRatesIndex = () => {
  const { t } = useTranslation('customerShippingRates')
  const history = useHistory()
  const { tab } = useParams()
  const activeTab = tab === FULL_TRUCK_LOAD_TAB ? FULL_TRUCK_LOAD_TAB : BASKET_SIZE_TAB

  useEffect(() => {
    document.title = 'Customer Shipping Rates | OSH CRM'
  }, [])

  const items = [
    {
      key: BASKET_SIZE_TAB,
      label: t('tabs.basketSize'),
      children: <BasketSizeRatesTab />
    },
    {
      key: FULL_TRUCK_LOAD_TAB,
      label: t('tabs.fullTruckLoad'),
      children: <FullTruckLoadRatesTab />
    }
  ]

  return (
    <Layout>
      <LayoutContentWrapper breadcrumbs={[
        { path: BASE_PATH, name: t('title') }
      ]}>
        <ContentLayout>
          <Tabs
            activeKey={activeTab}
            destroyOnHidden
            items={items}
            onChange={key => history.push(TAB_PATHS[key])}
          />
        </ContentLayout>
      </LayoutContentWrapper>
    </Layout>
  )
}

export default CustomerShippingRatesIndex
